import React, { useState, useEffect } from 'react';
import { Link , withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { connect } from "react-redux";
import * as actions from "redux/actions/sessionActions";
import logo1 from 'assets/images/ebiTrade_white.png';

import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import 'assets/css/signin.css';
import Tos from "./components/Tos";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TurnstileWidget from "./components/TurnstileWidget";
import { config } from "../../config";
import { Translate, I18n } from "react-redux-i18n";

const schema = {
  name: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 32
    }
  },
  lastN: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 32
    }
  },
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    passwordPolicy: true,
    length: {
      maximum: 128
    }
  },
  policy: {
    inclusion: {
      within: [true],
      message: '^must be accepted',
    },
  },
};

// const useStyles = {
//   root: {
//     backgroundColor: theme.palette.background.default,
//     height: '100%'
//   },
//   grid: {
//     height: '100%'
//   },
//   quoteContainer: {
//     [theme.breakpoints.down('md')]: {
//       display: 'none'
//     }
//   },
//   quote: {
//     backgroundColor: theme.palette.neutral,
//     height: '100%',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     backgroundSize: 'cover',
//     backgroundRepeat: 'no-repeat',
//     backgroundPosition: 'center'
//   },
//   quoteInner: {
//     textAlign: 'center',
//     flexBasis: '600px'
//   },
//   quoteText: {
//     color: theme.palette.black,
//     fontWeight: 300
//   },
//   name: {
//     marginTop: theme.spacing(3),
//     color: theme.palette.black
//   },
//   bio: {
//     color: theme.palette.black
//   },
//   contentContainer: {},
//   content: {
//     height: '100%',
//     display: 'flex',
//     flexDirection: 'column'
//   },
//   contentHeader: {
//     display: 'flex',
//     alignItems: 'center',
//     paddingTop: theme.spacing(5),
//     paddingBototm: theme.spacing(2),
//     paddingLeft: theme.spacing(2),
//     paddingRight: theme.spacing(2)
//   },
//   logoImage: {
//     marginLeft: theme.spacing(4)
//   },
//   contentBody: {
//     flexGrow: 1,
//     display: 'flex',
//     alignItems: 'center',
//     [theme.breakpoints.down('md')]: {
//       justifyContent: 'center'
//     }
//   },
//   form: {
//     paddingLeft: 100,
//     paddingRight: 100,
//     paddingBottom: 125,
//     flexBasis: 700,
//     [theme.breakpoints.down('sm')]: {
//       paddingLeft: theme.spacing(2),
//       paddingRight: theme.spacing(2)
//     }
//   },
//   title: {
//     marginTop: theme.spacing(3)
//   },
//   textField: {
//     marginTop: theme.spacing(2)
//   },
//   policy: {
//     marginTop: theme.spacing(1),
//     display: 'flex',
//     alignItems: 'center'
//   },
//   policyCheckbox: {
//     marginLeft: '-14px',
//     color:theme.palette.icon
//   },
//   policyText:{
//     //  color:theme.palette.icon
//   },
//   signUpButton: {
//     margin: theme.spacing(2, 0)
//   }
// };

const SignUp = props => {
  const { history } = props;
  const turnstileEnabled = config.turnstile.enabled;
  const [formStartedAt] = useState(() => Date.now());
  const [turnstileToken, setTurnstileToken] = useState('');

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      website: '',
    },
    touched: {},
    errors: {},
    showPassword: false,
  });

  const translateError = (message) => {
    if (!message) return null;
    const key = message.startsWith('^') ? message.slice(1) : message;
    const translated = I18n.t(key);
    return translated !== key ? translated : message;
  };

  useEffect(() => {
    props.Logout();
  }, []);

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState((prev) => ({
      ...prev,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.values]);

  useEffect(() => {
    if (props.error) {
      alertify.error(translateError(props.error));
    }
  }, [props.error]);

  useEffect(() => {
    if (props.success) {
      alertify.success(translateError(props.success));
      history.push('/login');
    }
  }, [props.success, history]);

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleBack = () => {
    history.goBack();
  };

  const handleSignUp = async (event) => {
    event.preventDefault();
    if (!formState.isValid) {
      return;
    }

    if (turnstileEnabled && !turnstileToken) {
      alertify.error(I18n.t('captcha_required'));
      return;
    }

    const result = await props.Register({
      ...formState.values,
      formStartedAt,
      turnstileToken: turnstileEnabled ? turnstileToken : undefined,
    });
    if (result?.success) {
      setTurnstileToken('');
      setFormState({
        isValid: false,
        values: { website: '' },
        touched: {},
        errors: {},
        showPassword: false,
      });
    }
  };

   const handleClickShowPassword = () => {
    setFormState(formState => ({
      ...formState,
      showPassword: !formState.showPassword,
    }));
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
     <div className='sign-in-page'>
      <container className='signin-container'> 
        <div>
          <a
            className='signin-hero'
            href="https://www.ebitrade.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="EbiTrade"
          >
          <img alt="Logo" src={logo1} className='img-logo' />
          <h1>
            Trading Log / Bitácora de Trading
          </h1>
          <p>
                Elecsotech
          </p>
          </a>
        </div>
          
        <div className='signin-card'>
          <div className='signin-header'>
            <h2 className='signin-title'>
              <Translate value="create_account" />
            </h2>
            <span className="signin-subtitle">
            <Translate value="create_email" />
            </span>
          </div>
          <form className='sign-form'
            onSubmit={handleSignUp}
            autoComplete="off"
          >
            <div className="signup-honeypot" aria-hidden="true">
              <label htmlFor="signup-website">Website</label>
              <input
                id="signup-website"
                name="website"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                value={formState.values.website || ''}
                onChange={handleChange}
              />
            </div>
            
            <div className='form-group'>
            <input
              className='input'
              error={hasError('name')}
              fullWidth
              helperText={
                hasError('name') ? translateError(formState.errors.name[0]) : null
              }
              placeHolder={I18n.t("first_name")}
              name="name"
              onChange={handleChange}
              type="text"
              value={formState.values.name || ''}
              variant="outlined"
            />
            
            <input
                className='input'
              error={hasError('lastN')}
              fullWidth
              helperText={
                hasError('lastN') ? translateError(formState.errors.lastN[0]) : null
              }

              placeHolder={I18n.t("last_name")}
              name="lastN"
              onChange={handleChange}
              type="text"
              value={formState.values.lastN || ''}
              variant="outlined"
            />
            
          
            <input
                className='input'
              error={hasError('email')}
              fullWidth
              helperText={
                hasError('email') ? translateError(formState.errors.email[0]) : null
              }
              placeHolder="Email"
              name="email"
              onChange={handleChange}
              type="email"
              value={formState.values.email || ''}
              variant="outlined"
            />
          <div className='password-row'>
            <input
              className='input'
              error={hasError('password')}
              fullWidth
              helperText={
                hasError('password') ? translateError(formState.errors.password[0]) : null
              }
              placeHolder={I18n.t("password")}
              name="password"
              onChange={handleChange}
               type={formState.showPassword ? 'text' : 'password'}
              value={formState.values.password || ''}
              autoComplete="new-password"
            />
            <span
                    className="pwd-toggle"
                    onClick={handleClickShowPassword}
                  >
                    {formState.showPassword ? '👁️' : '🔒'} 
            </span>
          </div>
          <p className="password-hint">
            <Translate value="password_policy_requirements" />
          </p>
          {hasError('password') && (
            <span className="field-error">
              {translateError(formState.errors.password[0])}
            </span>
          )}
              <div className="tos-accept-row">
                <input
                  id="signup-policy"
                  className="input-checkbox"
                  type="checkbox"
                  name="policy"
                  checked={!!formState.values.policy}
                  onChange={handleChange}
                />
                <span style={{display: 'content'}}>
                  <label htmlFor="signup-policy" className="tos-accept-label">
                    <Translate value="i_read" />
                  </label>{' '}
                  <Tos />
                  {' '}<Translate value="and" />{' '}
                  <PrivacyPolicy />
                </span>
              </div>
              {hasError('policy') && (
                <span className="field-error">
                  {translateError(formState.errors.policy[0])}
                </span>
              )}
              {turnstileEnabled && (
                <TurnstileWidget onToken={setTurnstileToken} />
              )}
            <button
              className='btn btn-primary btn-block mt-2'
              disabled={!formState.isValid}
              type="submit"
            >
              <Translate value="signup_now" />
            </button>
            <p className='signin-sugestion mt-3'>
              <span className='text-muted f-14'>
                <Translate value="have_account" />{' '}
              </span>
              <Link className="linked-primary link-underline-opacity-0"
                to="/sign-in"
              >
                <Translate value="sign_in" />
              </Link>
            </p>
              </div>
          </form>
        </div>
      </container >
    </div >
  );
};

SignUp.propTypes = {
  history: PropTypes.object
};

function mapStateToProps(reducer) {
  //console.log(reducer);
  return {
    error: reducer.session.error,
    success: reducer.session.success,
  };
}

const mapDispatchToProps = dispatch => ({
  Register: (params) =>
    dispatch(actions.register({ params })),
  Logout: () =>
    dispatch(actions.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
//export default withRouter(SignUp);
/**
 *  <div className={classes.contentHeader}>
              <IconButton onClick={handleBack}>
                <ArrowBackIcon />
              </IconButton>
            </div>
 * <Link
                      color="primary"
                      component={RouterLink}
                      to="#"
                      underline="always"
                      variant="h6"
                    >
                    </Link>
 */
